<template>
  <NButton label="Button" />
</template>
